import * as d3v4 from 'd3';

angular.module('d3', []).constant('d3', window.d3).constant('d3v4', d3v4);
